import React from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSection} from "../../containers/MainSection/MainSection"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import EmailTemplates from "./EmailTemplates"
import EmailTemplateVersions from "./EmailTemplateVersions"
import ReadyToLaunchAdmin from "./ReadyToLaunchAdmin/ReadyToLaunchAdmin"
import {useParams} from "react-router-dom"
import {useQueryState} from "use-location-state"

type AdminTabs = "Email Templates" | "Ready to Launch"

function TabContent({
	currentTab,
	refresh,
	templateId,
	templateName,
}: {
	currentTab: AdminTabs
	refresh: () => void
	templateId?: string
	templateName?: string
}) {
	if (templateId) {
		return <EmailTemplateVersions templateId={templateId} templateName={templateName} refresh={refresh} />
	}

	switch (currentTab) {
		case "Ready to Launch":
			return <ReadyToLaunchAdmin />
		case "Email Templates":
		default:
			return <EmailTemplates refresh={refresh} />
	}
}

function AdminPageInternal({
	refresh,
	templateId,
	templateName,
}: {
	refresh: () => void
	templateId?: string
	templateName?: string
}) {
	const [currentTab, setCurrentTab] = useQueryState<AdminTabs>("tab", "Email Templates")
	const title = templateId ? `Email Template Versions` : "Admin Dashboard"

	const breadcrumbs = templateId ? [{text: "Email Templates", path: "/admin"}] : undefined

	const tabs: AdminTabs[] = ["Email Templates", "Ready to Launch"]

	return (
		<>
			<TitleBar title={title} className={"title-bar-no-border"} breadcrumbs={breadcrumbs} />

			{!templateId && (
				<nav className="admin-settings tabs-container">
					<div className="tabs">
						<ul>
							{tabs.map((tab) => (
								<li key={tab} className={currentTab === tab ? "is-active" : ""}>
									<a onClick={() => setCurrentTab(tab)} style={{cursor: "pointer"}}>
										{tab}
									</a>
								</li>
							))}
						</ul>
					</div>
				</nav>
			)}

			<MainSection>
				<TabContent currentTab={currentTab} refresh={refresh} templateId={templateId} templateName={templateName} />
			</MainSection>
		</>
	)
}

export default function AdminPage() {
	// Create refreshToken once and use it only for the refresh function
	const [, refresh] = useRefreshToken()
	const params = useParams<{templateId?: string; templateName?: string}>()
	const templateId = params.templateId
	const templateName = params.templateName ? decodeURIComponent(params.templateName) : undefined

	return <AdminPageInternal refresh={refresh} templateId={templateId} templateName={templateName} />
}
